import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import ListingCardsBody from './ListingCardsBody';
import ListingCardsData from './ListingCardsData';

const Edit = (props) => {
  const { data, block, selected, pathname, intl } = props;

  return (
    <>
      <ListingCardsBody {...props} path={pathname} intl={intl} isEditMode />
      <SidebarPortal selected={selected}>
        <ListingCardsData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
